var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-pipeline-test" }, [
    _c("h1", [_vm._v("Pipeline")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "pta-pipeline-sort" }, [
      _c("ul", [
        _c(
          "li",
          {
            class:
              _vm.pta_sort_by == "created"
                ? _vm.pta_sort_dir == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.pta_sort_by = "created"
                  ? _vm.pta_sort_dir == "desc"
                    ? (_vm.pta_sort_dir = "asc")
                    : (_vm.pta_sort_dir = "desc")
                  : (_vm.pta_sort_dir = "asc")
                _vm.pta_sort_by = "created"
              },
            },
          },
          [_c("span", [_vm._v("Date created")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.pta_sort_by == "name"
                ? _vm.pta_sort_dir == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.pta_sort_by = "name"
                  ? _vm.pta_sort_dir == "desc"
                    ? (_vm.pta_sort_dir = "asc")
                    : (_vm.pta_sort_dir = "desc")
                  : (_vm.pta_sort_dir = "asc")
                _vm.pta_sort_by = "name"
              },
            },
          },
          [_c("span", [_vm._v("Name")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.pta_sort_by == "value"
                ? _vm.pta_sort_dir == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.pta_sort_by = "value"
                  ? _vm.pta_sort_dir == "desc"
                    ? (_vm.pta_sort_dir = "asc")
                    : (_vm.pta_sort_dir = "desc")
                  : (_vm.pta_sort_dir = "asc")
                _vm.pta_sort_by = "value"
              },
            },
          },
          [_c("span", [_vm._v("Value")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.pta_sort_by == "close"
                ? _vm.pta_sort_dir == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.pta_sort_by = "close"
                  ? _vm.pta_sort_dir == "desc"
                    ? (_vm.pta_sort_dir = "asc")
                    : (_vm.pta_sort_dir = "desc")
                  : (_vm.pta_sort_dir = "asc")
                _vm.pta_sort_by = "close"
              },
            },
          },
          [_c("span", [_vm._v("Close date")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.pta_sort_by == "updates"
                ? _vm.pta_sort_dir == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.pta_sort_by = "updates"
                  ? _vm.pta_sort_dir == "desc"
                    ? (_vm.pta_sort_dir = "asc")
                    : (_vm.pta_sort_dir = "desc")
                  : (_vm.pta_sort_dir = "asc")
                _vm.pta_sort_by = "updates"
              },
            },
          },
          [_c("span", [_vm._v("Last updates")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class:
              _vm.pta_sort_by == "state"
                ? _vm.pta_sort_dir == "asc"
                  ? "active-asc"
                  : "active-desc"
                : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.pta_sort_by = "state"
                  ? _vm.pta_sort_dir == "desc"
                    ? (_vm.pta_sort_dir = "asc")
                    : (_vm.pta_sort_dir = "desc")
                  : (_vm.pta_sort_dir = "asc")
                _vm.pta_sort_by = "state"
              },
            },
          },
          [_c("span", [_vm._v("State")])]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pta-pipeline-campaigns" }, [
      _c("div", { staticClass: "pta-pipeline-campaign" }, [
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
          _c(
            "ul",
            {
              staticClass:
                "pta-pipeline-statusline pta-pipeline-color-1 pta-pipeline-size-9",
              class: _vm.show_index == 1 ? "pta-pipeline-show-labels" : "",
            },
            [
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _vm._m(7),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _vm._m(10),
              _vm._v(" "),
              _vm._m(11),
            ]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "pta-pipeline-icon-show",
            class: _vm.show_index == 1 ? "pta-pipeline-icon-hide" : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.show_index == 1
                  ? (_vm.show_index = 0)
                  : (_vm.show_index = 1)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
          _c(
            "span",
            {
              staticClass: "pta-pipeline-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.selected_index == 1
                    ? (_vm.selected_index = 0)
                    : (_vm.selected_index = 1)
                },
              },
            },
            [_vm._v("View details")]
          ),
        ]),
        _vm._v(" "),
        _vm.selected_index == 1
          ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\n      "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pta-pipeline-campaign" }, [
        _vm._m(12),
        _vm._v(" "),
        _vm._m(13),
        _vm._v(" "),
        _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
          _c(
            "ul",
            {
              staticClass:
                "pta-pipeline-statusline pta-pipeline-color-2 pta-pipeline-size-9",
              class: _vm.show_index == 2 ? "pta-pipeline-show-labels" : "",
            },
            [
              _vm._m(14),
              _vm._v(" "),
              _vm._m(15),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _vm._m(17),
              _vm._v(" "),
              _vm._m(18),
              _vm._v(" "),
              _vm._m(19),
              _vm._v(" "),
              _vm._m(20),
              _vm._v(" "),
              _vm._m(21),
              _vm._v(" "),
              _vm._m(22),
            ]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "pta-pipeline-icon-show",
            class: _vm.show_index == 2 ? "pta-pipeline-icon-hide" : "",
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.show_index == 2
                  ? (_vm.show_index = 0)
                  : (_vm.show_index = 2)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
          _c(
            "span",
            {
              staticClass: "pta-pipeline-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.selected_index == 2
                    ? (_vm.selected_index = 0)
                    : (_vm.selected_index = 2)
                },
              },
            },
            [_vm._v("View details")]
          ),
        ]),
        _vm._v(" "),
        _vm.selected_index == 2
          ? _c("div", { staticClass: "pta-pipeline-campaign-details" }, [
              _vm._v(
                "\n        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\n      "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-status" }, [
      _c("ul", [
        _c("li", [_c("span", [_vm._v("2")]), _vm._v("Active Deals")]),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v("£90,000.00")]),
          _vm._v("Average Deal Value"),
        ]),
        _vm._v(" "),
        _c("li", [_c("span", [_vm._v("0%")]), _vm._v("Success Rate")]),
        _vm._v(" "),
        _c("li", [
          _c("span", [_vm._v("48 "), _c("i", [_vm._v("Days")])]),
          _vm._v("Average Deal Lifespan"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
      _c("h3", [_vm._v("Independent Financial Advisor")]),
      _vm._v(" "),
      _c("h4", [_vm._v("Stefan Richter")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
      _c("span", { staticClass: "pta-pipeline-amount" }, [
        _vm._v("£45,000.00"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "pta-pipeline-date" }, [_vm._v("03.05.2023")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Conversation started")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Teaser sended")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Presentation")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Case Studies")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("FAQ/DDQ")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Track Record")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Share Data Room")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Raise Capital")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Money Transfer")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-left" }, [
      _c("h3", [_vm._v("Sango Capital Management")]),
      _vm._v(" "),
      _c("h4", [_vm._v("Jonny Sengendo")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pta-pipeline-campaign-right" }, [
      _c("span", { staticClass: "pta-pipeline-amount" }, [
        _vm._v("£45,000.00"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "pta-pipeline-date" }, [_vm._v("12.04.2023")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Conversation started")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Teaser sended")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Presentation sended")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "active" }, [
      _c("div", [_c("span", [_vm._v("Case Studies sended")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("FAQ/DDQ")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Track Record")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Share Data Room")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Raise Capital")])])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("div", [_c("span", [_vm._v("Money Transfer")])])])
  },
]
render._withStripped = true

export { render, staticRenderFns }